import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-link-m text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-lg text-background-50">
                  地址发布页
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                官方唯一指定的地址入口导航平台。收藏本页，永不迷路。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/zixun"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    最新资讯
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/jiaocheng"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    使用教程
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">
                帮助中心
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/category/wenti"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    常见问题
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/anquan"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    安全指南
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/gengxin"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    版本更新
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">
                官方声明
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                本网站为官方唯一指定的地址发布平台。请认准官方域名，谨防钓鱼网站。如有疑问，请通过官方渠道联系我们核实。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2026 地址发布页 版权所有 | 本站为官方唯一指定地址入口导航平台
              </p>
              <div className="flex items-center gap-5">
                <a
                  href="#"
                  className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer"
                >
                  隐私政策
                </a>
                <a
                  href="#"
                  className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer"
                >
                  服务条款
                </a>
                <a
                  href="#"
                  className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer"
                >
                  网站地图
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}